/**
 * File-type icon lookup. Returns a Phosphor icon component for a kind string
 * (see fileKind in api/resources.js).
 */
import {
  File,
  FileImage,
  FileVideo,
  FileAudio,
  FilePdf,
  FileDoc,
  FileXls,
  FilePpt,
  FileZip,
} from "@phosphor-icons/react";

const MAP = {
  image: FileImage,
  video: FileVideo,
  audio: FileAudio,
  pdf: FilePdf,
  doc: FileDoc,
  sheet: FileXls,
  slides: FilePpt,
  archive: FileZip,
  file: File,
};

export default function FileIcon({ kind, size = 18, weight = "regular", className = "" }) {
  const Icon = MAP[kind] || File;
  return <Icon size={size} weight={weight} className={className} />;
}
